// extracted by css-extract-rspack-plugin
export default {"inherit":"css-inherit-9e68b6"};